import styled from "styled-components";

const Line = styled.div`
    white-space: break-spaces;
`;

export default Line;